
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestzantaclawyers",
      function () {
        return require("private-next-pages/bestzantaclawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestzantaclawyers"])
      });
    }
  